import React from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EngineeringIcon from "@mui/icons-material/Engineering";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ScienceIcon from "@mui/icons-material/Science";
import SecurityIcon from "@mui/icons-material/Security";
import GroupsIcon from "@mui/icons-material/Groups";
import VerifiedIcon from "@mui/icons-material/Verified";
import PublicIcon from "@mui/icons-material/Public";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";

import SelexMB from "../images/SelexMB Final.png";
import SelexSIM from "../images/SelexSIM.png";
import SelexRISK from "../images/SelexRISK.png";
import optimizeLogo from "../images/logooptimizegsfinal.png";
import Footer from "./Footer";

const primary = "#0078c9";
const accent = "#9e0b22";
const navy = "#061d34";

const modules = [
  {
    name: "SelexMB™",
    title: "AI-Driven Operations",
    logo: SelexMB,
    icon: <AutoAwesomeIcon />,
    route: "/selexmblanding",
    tag: "AI + ML Operations",
    desc: "SelexMB™ empowers energy companies to use artificial intelligence, machine learning, ANN tools, and hybrid modeling for enhanced decision-making and autonomous operations.",
  },
  {
    name: "SelexSIM™",
    title: "Simulation Intelligence",
    logo: SelexSIM,
    icon: <ScienceIcon />,
    route: "/selexsimlanding",
    tag: "Modeling + Optimization",
    desc: "SelexSIM™ simplifies advanced mathematical modeling, Lean Model Dynamics, stochastic and discrete simulations, process monitoring, and optimization workflows.",
  },
  {
    name: "SelexRISK™",
    title: "Risk & Safety Intelligence",
    logo: SelexRISK,
    icon: <SecurityIcon />,
    route: "/selectselexrisk",
    tag: "Risk + Reliability",
    desc: "SelexRISK™ supports process hazard analysis, risk matrices, consequence modeling, mitigation planning, probability of failure, and proactive safety decisions.",
  },
];

const values = [
  {
    icon: <EngineeringIcon />,
    title: "Engineering Excellence",
    desc: "Deep technical expertise for complex energy, chemicals, resources, and industrial asset challenges.",
  },
  {
    icon: <GroupsIcon />,
    title: "Empowered Experts",
    desc: "Committed, innovative, and experienced people focused on practical engineering outcomes.",
  },
  {
    icon: <VerifiedIcon />,
    title: "Safety & Reliability",
    desc: "A strong focus on health, safety, environment, process safety, and operational reliability.",
  },
  {
    icon: <PublicIcon />,
    title: "Sustainable Progress",
    desc: "Solutions that support operational performance, sustainability, optimization, and long-term social progress.",
  },
];

function AboutPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at 8% 10%, rgba(0,120,201,0.08), transparent 28%), radial-gradient(circle at 90% 12%, rgba(158,11,34,0.07), transparent 25%), #ffffff",
        overflowX: "hidden",
      }}
    >
      <SelexSolNavbar />

      <Box
        sx={{
          width: "min(1180px, calc(100% - 32px))",
          mx: "auto",
          pt: { xs: 11, md: 12 },
          pb: 8,
        }}
      >
        {/* HERO */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.05fr 0.95fr" },
            gap: 3,
            alignItems: "center",
            mb: { xs: 6, md: 8 },
          }}
        >
          <Box>
           

            <Chip
              label="About OptimizeXP"
              sx={{
                bgcolor: "rgba(158,11,34,0.08)",
                color: "#0078c9",
                fontWeight: 900,
                fontSize : 32,
                letterSpacing: 0.5,
                mb: 2,
                p:1
              }}
            />

            <Typography
              component="h1"
              sx={{
                fontSize: { xs: 38, sm: 52, md: 68 },
                lineHeight: 0.98,
                fontWeight: 950,
                letterSpacing: { xs: "-1.6px", md: "-3px" },
                color: navy,
                mb: 2,
              }}
            >
              Engineering consulting powered by <Box component="span" sx={{ color: primary }}>digital</Box>{" "}
              <Box component="span" sx={{ color: accent }}>intelligence</Box>
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 15, md: 18 },
                color: "#64748b",
                lineHeight: 1.8,
                maxWidth: 760,
                mb: 3.5,
              }}
            >
              OptimizeXP provides engineering consulting, advisory services, and intelligent software platforms for energy, chemicals, resources, and industrial operations. Through SelexMB™, SelexSIM™, and SelexRISK™, the company connects AI-driven operations, simulation intelligence, and process safety into one practical digital ecosystem.
            </Typography>

            <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
              <Button href="#modules" endIcon={<ArrowForwardIcon />} sx={ExploreBtn}>
                Explore Modules
              </Button>
              <Button href="#mission" sx={outlineBtn}>
                Our Mission
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
              borderRadius: "34px",
              p: { xs: 3, md: 4 },
              background: navy,
              color: "#fff",
              overflow: "hidden",
              boxShadow: "0 26px 70px rgba(6,29,52,0.22)",
              border: "1px solid rgba(0,120,201,0.18)",
            
         
            }}
          >
            <Box sx={{ position: "relative", zIndex: 2 }}>
              <Box
                sx={{
                  width: 185,
                  height: 86,
                  borderRadius: "22px",
                  bgcolor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 14px 34px rgba(0,0,0,0.22)",
                  mb: 3,
                }}
              >
                <Box component="img" src={optimizeLogo} alt="OptimizeXP" sx={{ width: 155, objectFit: "contain" }} />
              </Box>

              <Typography sx={{ fontSize: { xs: 32, md: 44 }, fontWeight: 950, lineHeight: 1, mb: 3 }}>
                Consulting + Software + Industrial AI
              </Typography>

              <Box sx={{ display: "grid", gap: 1.5 }}>
                {[
                  ["Engineering", "Consulting, asset management, PMC, training and advisory support"],
                  ["Digital Solutions", "SelexMB, SelexSIM and SelexRISK platforms for industrial teams"],
                  ["Operations", "Optimization, simulation, risk, process safety and reliability workflows"],
                ].map(([title, desc]) => (
                  <Box
                    key={title}
                    sx={{
                      p: 2,
                      borderRadius: "18px",
                      bgcolor: "rgba(255,255,255,0.07)",
                      border: "1px solid rgba(255,255,255,0.10)",
                    }}
                  >
                    <Typography sx={{ fontWeight: 900,fontSize:16, color: "#fff", mb: 0.4 }}>{title}</Typography>
                    <Typography sx={{ fontSize: 14, color: "rgba(255,255,255,0.62)", lineHeight: 1.6 }}>{desc}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>

        {/* MISSION */}
        <Box
          id="mission"
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "0.95fr 1.05fr" },
            gap: 3,
            mb: { xs: 6, md: 8 },
          }}
        >
          <Box sx={whitePanelStyle}>
            <Typography sx={eyebrowStyle}>Our Purpose</Typography>
            <Typography sx={sectionHeadingStyle}>To make engineering decisions smarter, safer, and more productive.</Typography>
            <Typography sx={bodyTextStyle}>
OptimizeXP aims to be the most competitive and the most productive engineering consultant in the world. Our core competencies in engineering, PMC and training are being continuously improved to be best-in-class. Our visions:

            </Typography>
          </Box>

          <Box sx={navyPanelStyle}>
            <Typography sx={{ color: "#9bd7ff", fontSize: 20, fontWeight: 950, letterSpacing: 1.2, textTransform: "uppercase", mb: 1 }}>
              What We Deliver
            </Typography>
            <Typography sx={{ color: "#fff", fontSize: { xs: 28, md: 38 }, fontWeight: 950, mb: 2, letterSpacing: "-1px" }}>
              A connected ecosystem for modern industrial teams
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.72)", lineHeight: 1.85, fontSize: 14 }}>
              The company combines consulting expertise with software platforms that support AI-based operations, mathematical modeling, risk management, process safety, asset integrity, and performance optimization. This helps engineering, R&D, operations, and safety teams move from raw data and simulation files to clear decisions.
            </Typography>
          </Box>
        </Box>

        {/* VALUES */}
        <Box sx={{ mb: { xs: 6, md: 8 } }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography sx={eyebrowStyle}>Core Strengths</Typography>
            <Typography sx={{ ...sectionHeadingStyle, maxWidth: 760, mx: "auto" }}>
              Built around engineering quality, safety, and sustainable progress
            </Typography>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(4, 1fr)" },
              gap: 2.5,
            }}
          >
            {values.map((item, index) => (
              <Box key={item.title} sx={valueCardStyle(index)}>
                <Box sx={valueIconStyle}>{item.icon}</Box>
                <Typography sx={{ color: navy, fontSize: 20, fontWeight: 950, mb: 1 }}>
                  {item.title}
                </Typography>
                <Typography sx={{ color: "#64748b", fontSize: 14, lineHeight: 1.75 }}>
                  {item.desc}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* MODULES */}
        <Box id="modules" sx={{ mb: { xs: 6, md: 8 } }}>
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography sx={eyebrowStyle}>SelexSuite Modules</Typography>
            <Typography sx={{ ...sectionHeadingStyle, maxWidth: 820, mx: "auto" }}>
              Three platforms that connect operations, simulation, and risk
            </Typography>
            <Typography sx={{ color: "#64748b", maxWidth: 760, mx: "auto", lineHeight: 1.75, mt: 1.5 }}>
              OptimizeXP provides these three core modules as a unified digital suite for industrial decision support.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
              gap: 3,
            }}
          >
            {modules.map((item, index) => (
              <Box key={item.name} sx={moduleCardStyle(index)}>
                <Box sx={{ position: "relative", zIndex: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
                    <Box sx={logoBoxStyle}>
                      <Box component="img" src={item.logo} alt={item.name} sx={{ width: 66, maxHeight: 66, objectFit: "contain" }} />
                    </Box>
                  </Box>

                  <Chip label={item.tag} size="small" sx={chipStyle(index)} />

                  <Typography sx={{ fontSize: 25, fontWeight: 950, color: navy, mb: 1 }}>
                    {item.name}
                  </Typography>
                  <Typography sx={{ fontSize: 15, fontWeight: 850, color: primary, mb: 1.5 }}>
                    {item.title}
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#64748b", lineHeight: 1.78, mb: 3 }}>
                    {item.desc}
                  </Typography>

                  <Button href={item.route} endIcon={<ArrowForwardIcon />} sx={softButtonStyle(index)}>
                    Explore {item.name.replace("™", "")}
                  </Button>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>

        {/* CTA */}
        <Box sx={ctaStyle}>
          <Typography sx={{ color: "#fff", fontSize: { xs: 30, md: 46 }, fontWeight: 950, letterSpacing: "-1.4px", mb: 1.5 }}>
            One company. Three intelligent engineering platforms.
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.72)", maxWidth: 760, mx: "auto", lineHeight: 1.8, mb: 3 ,fontSize:14 }}>
            From AI-based operations to simulation and risk intelligence, OptimizeXP helps industrial teams move faster, work safer, and make better decisions.
          </Typography>
          <Button href="#modules" endIcon={<ArrowForwardIcon />} sx={ExploreBtn}>
            View SelexSuite Modules
          </Button>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

const primaryBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  background: `linear-gradient(135deg, ${accent}, #75081a)`,
  color: "#fff",
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: `linear-gradient(135deg, ${accent}, #75081a)`,
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
    color:"#fff"
  },
};



const ExploreBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: `linear-gradient(135deg, ${accent}, #75081a)`,
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
    color:"#fff"
  },
};

const outlineBtn = {
  px: 3,
  py: 1.35,
  borderRadius: "999px",
  color: primary,
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  background: "#fff",
  border: "1px solid rgba(0,120,201,0.25)",
  "&:hover": {
    color: accent,
    borderColor: accent,
    background: "rgba(158,11,34,0.04)",
    transform: "translateY(-2px)",
  },
};

const eyebrowStyle = {
  color: accent,
  fontSize: 20,
  fontWeight: 950,

  letterSpacing: 1.2,
  textTransform: "uppercase",
  mb: 1,
};

const sectionHeadingStyle = {
  color: navy,
  fontSize: { xs: 28, md: 40 },
  fontWeight: 950,
  letterSpacing: "-1.3px",
  lineHeight: 1.12,
  mb: 1.5,
};

const bodyTextStyle = {
  color: "#64748b",
  lineHeight: 1.85,
  fontSize: 15,
};

const whitePanelStyle = {
  p: { xs: 3, md: 4 },
  borderRadius: "32px",
  background: "#fff",
  border: "1px solid rgba(0,120,201,0.14)",
  boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
  position: "relative",
  overflow: "hidden",

};

const navyPanelStyle = {
  p: { xs: 3, md: 4 },
  borderRadius: "32px",
  background: navy,
  color: "#fff",
  border: "1px solid rgba(0,120,201,0.16)",
  boxShadow: "0 24px 65px rgba(6,29,52,0.16)",
  position: "relative",
  overflow: "hidden",
  "&:before": {
    content: '""',
    position: "absolute",
    width: 220,
    height: 220,
    right: -80,
    top: -80,
    borderRadius: "50%",
    background: "radial-gradient(circle, rgba(0,120,201,0.36), transparent 68%)",
  },
};

const valueCardStyle = (index) => ({
  p: 3,
  borderRadius: "28px",
  background: "rgba(255,255,255,0.92)",
  border: "1px solid rgba(0,120,201,0.13)",
  boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
  transition: "0.3s ease",
  position: "relative",
  overflow: "hidden",
  "&:hover": {
    transform: "translateY(-8px)",
    boxShadow: "0 28px 70px rgba(0,120,201,0.15)",
    borderColor: primary,
  },

});

const valueIconStyle = {
  width: 54,
  height: 54,
  borderRadius: "18px",
  display: "grid",
  placeItems: "center",
  color: "#fff",
  background: "#0078c9",
  boxShadow: "0 14px 30px rgba(0,120,201,0.20)",
  mb: 2,
  "& svg": { fontSize: 27 },
};

const moduleCardStyle = (index) => ({
  p: 3.2,
  borderRadius: "32px",
  background: "rgba(255,255,255,0.92)",
  backdropFilter: "blur(18px)",
  overflow: "hidden",
  border: "1px solid rgba(0,120,201,0.13)",
  boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
  transition: "0.35s ease",
  position: "relative",
  minHeight: 390,
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0 30px 75px rgba(0,120,201,0.18)",
    borderColor: primary,
  },
 
});

const logoBoxStyle = {
  width: 88,
  height: 88,
  borderRadius: "26px",
  background: "linear-gradient(135deg, #ffffff, #f4f9ff)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 16px 38px rgba(6,29,52,0.10)",
  border: "1px solid rgba(0,120,201,0.10)",
};

const gradientIconStyle = {
  width: 50,
  height: 50,
  borderRadius: "18px",
  display: "grid",
  placeItems: "center",
  color: "#fff",
  background: `linear-gradient(135deg, ${primary}, ${accent})`,
  boxShadow: "0 14px 30px rgba(0,120,201,0.22)",
  "& svg": { fontSize: 25 },
};

const chipStyle = (index) => ({
  bgcolor: index % 2 === 0 ? "rgba(0,120,201,0.10)" : "rgba(158,11,34,0.07)",
  color: index % 2 === 0 ? primary : accent,
  border: index % 2 === 0 ? "1px solid rgba(0,120,201,0.18)" : "1px solid rgba(158,11,34,0.12)",
  fontWeight: 900,
  mb: 2,
});

const softButtonStyle = (index) => ({
  mt: 1,
  px: 2.4,
  py: 1.15,
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 900,
  fontSize:12,
  color: "#fff",
  background: "#0078c9",
  "&:hover": {
    color: "#fff",
    background: accent,
    transform: "translateY(-2px)",
  },
});

const ctaStyle = {
  mb: 2,
  p: { xs: 3.5, md: 5.5 },
  textAlign: "center",
  borderRadius: "34px",
 background:
      "radial-gradient(circle at 12% 18%, rgba(0,120,201,0.18), transparent 34%),radial-gradient(circle at 90% 24%, rgba(158,11,34,0.14), transparent 28%),linear-gradient(135deg, #061d34 0%, #082f56 52%, #04121f 100%)",
      
  boxShadow: "0 24px 70px rgba(6,29,52,0.22)",
};

export default AboutPage